module.exports = __webpack_public_path__ + "img/slider1.6e3899be.jpg";